/*
 * search-toggle.js -- ikona hledani v hlavicce (task BP, 7. 9., Q19).
 *
 * Rozbaluje/schovava `.hsearch-form` vedle jazykoveho prepinace (header.php).
 * Vzor je stejny jako u ostatnich chrome modulu (menu.js): vlastni
 * try/catch v index.js, zadny externi state, fail-open (chybejici prvky
 * = tichy navrat, nikdy throw).
 *
 * PROC INLINE TOGGLE, NE MODAL: `#th-mobile-panel` v menu.js resi
 * focus-trap + `inert` pro cely overlay; tohle pole je maly rozbalovaci
 * blok v ramci hlavicky, kde staci Esc + fokus + zavreni klikem mimo.
 * Dva nezavisle focus-trapy (menu + search) by rostly slozitost bez
 * uzitku -- search pole neni modal, jen skryty/odkryty kus DOM.
 */

export function init() {
	const toggles = document.querySelectorAll('.hsearch-toggle');
	if (!toggles.length) {
		return;
	}

	toggles.forEach(function (btn) {
		const wrap = btn.closest('.hsearch');
		if (!wrap) {
			return;
		}
		const form = wrap.querySelector('.hsearch-form');
		const input = form ? form.querySelector('input[type="search"]') : null;
		if (!form || !input) {
			return;
		}

		const labelOpen = btn.getAttribute('data-label-open') || btn.getAttribute('aria-label') || '';
		const labelClose = btn.getAttribute('data-label-close') || labelOpen;

		/*
		 * DOPLNEK 7 (animace dle stare sablony, viz chrome.css u
		 * `.hsearch-form.is-open`): `hidden` sam o sobe neanimuje (display
		 * neni animovatelna vlastnost), takze otevreni/zavreni je
		 * dvoukrokove -- `hidden` se odstrani/vrati AZ na hranici prechodu,
		 * `.is-open` rozhoduje o opacity/transform pres CSS transition.
		 * `closeTimer` hlida rozpracovane zavirani, kdyz uzivatel klikne
		 * znovu driv, nez prechod dobehne (zadny zavěsly setTimeout, ktery
		 * by pak skryl cerstve znovuotevrene pole).
		 */
		let closeTimer = null;

		function clearCloseTimer() {
			if (closeTimer !== null) {
				clearTimeout(closeTimer);
				closeTimer = null;
			}
		}

		function openSearch() {
			clearCloseTimer();
			form.hidden = false;
			// Force reflow mezi odebranim `hidden` a pridanim `.is-open`,
			// jinak prohlizec obe zmeny slouci do jednoho kroku a prechod
			// se neprehraje (skok rovnou do koncoveho stavu).
			void form.offsetWidth;
			form.classList.add('is-open');
			btn.setAttribute('aria-expanded', 'true');
			if (labelClose) {
				btn.setAttribute('aria-label', labelClose);
			}
			wrap.classList.add('is-open');
			input.focus();
		}

		function closeSearch(returnFocus) {
			clearCloseTimer();
			form.classList.remove('is-open');
			btn.setAttribute('aria-expanded', 'false');
			if (labelOpen) {
				btn.setAttribute('aria-label', labelOpen);
			}
			wrap.classList.remove('is-open');
			// `transitionend` zavre pole hned po doznění CSS prechodu;
			// fallback timeout (220 ms > 180 ms z chrome.css) je pojistka
			// pro prohlizece/stavy bez transition (napr. prefers-reduced
			// -motion, kde chrome.css transition vypina) -- pole se pak
			// schova okamzite misto zůstat trvale "otevrene" v DOM.
			closeTimer = setTimeout(function () {
				closeTimer = null;
				form.hidden = true;
			}, 220);
			if (returnFocus) {
				btn.focus();
			}
		}

		btn.addEventListener('click', function () {
			// `is-open`, ne `form.hidden`: behem 220ms zaviraciho prechodu
			// je `hidden` porad `false` (viz closeSearch), takze rychly
			// dvojklik ("zavri" + "otevri znovu") by bez teto kontroly
			// omylem zavolal closeSearch() podruhe misto znovuotevreni.
			if (form.classList.contains('is-open')) {
				closeSearch(true);
			} else {
				openSearch();
			}
		});

		/*
		 * BOD 7 (1.27.8): zavirajici tlacitko UVNITR pruhu (viditelne jen
		 * na mobilnim celosirem pruhu, `chrome.css`) vola STEJNOU
		 * `closeSearch()` jako `.hsearch-toggle` vys -- zadna nova logika,
		 * jen druha kotva. `type="button"` uz brani submitu formulare.
		 */
		const closeBtn = form.querySelector('[data-hsearch-close]');

		if (closeBtn) {
			closeBtn.addEventListener('click', function () {
				closeSearch(true);
			});
		}

		form.addEventListener('keydown', function (event) {
			if (event.key === 'Escape') {
				closeSearch(true);
			}
		});

		document.addEventListener('click', function (event) {
			if (!form.hidden && !wrap.contains(event.target)) {
				closeSearch(false);
			}
		});
	});
}
